import React, { useState, useMemo } from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { isValidFileSrc, isDeviationPixelArt, } from '../../../../DeviationViews/_helpers';
import { getSrcSet } from '../../../../DeviationViews/Dumbo/Image/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
import EditorDeviationLink from '../../_partials/DeviationLink';
import ZoomModal from '../../../../DeviationViews/Full/Image/ZoomModal';
import withFeatureFlags from '../../../../redux/flags/withFeatureFlags';
import MediaService from '../../../../utils/DeviationMediaService';
var Img = function (props) {
    var file = props.file, deviation = props.deviation, imgStyles = props.imgStyles;
    var width = props.width;
    if (!width || width === 'static') {
        width = 1920;
    }
    return (React.createElement("img", { src: file.src, srcSet: getSrcSet(deviation, width), alt: deviation.title, style: imgStyles }));
};
Img.displayName = 'Img';
var ImgWithFullview = function (props) {
    var _a = useState(false), showFullview = _a[0], setShowFullview = _a[1];
    var file = props.file, deviation = props.deviation, imgStyles = props.imgStyles, width = props.width;
    var fullview = useMemo(function () { return MediaService.getLargestFullview(deviation); }, [
        deviation,
    ]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function () {
                setShowFullview(true);
            }, style: { cursor: 'zoom-in' } },
            React.createElement(Img, { file: file, deviation: deviation, imgStyles: imgStyles, width: width })),
        showFullview && (React.createElement(ZoomModal, { file: fullview, isPixel: isDeviationPixelArt(deviation), onClose: function () {
                setShowFullview(false);
            } }))));
};
ImgWithFullview.displayName = 'ImgWithFullview';
var ImageView = function (props) {
    var deviation = props.deviation, propsWidth = props.width, config = props.config;
    var fullview = MediaService.getLargestFullview(deviation);
    if (!fullview) {
        ddt.log('Editor', 'Not rendering mono image - no fullview', deviation);
        return null;
    }
    // Calculate the width and height of the block
    var fvImageRatio = (fullview.width || 0) / (fullview.height || 0);
    var coverWidth = propsWidth === 'static' ? 780 : propsWidth || 780;
    var coverHeight = coverWidth / fvImageRatio;
    var coverThumb = MediaService.getSmallestThumbThatFullyCovers(deviation, coverWidth, coverHeight, function (t) { return t[t.length - 1]; }, { allowFullview: true, allowPreview: true });
    if (!coverThumb || !isValidFileSrc(coverThumb.src)) {
        ddt.log('Editor', 'Not rendering mono image', deviation);
        return null;
    }
    // Dont stretch things - max is the fullview width
    // we then let browser decide whats best using srcset
    var imgWidth = '100%';
    if ((fullview.width || 0) < (propsWidth || 0)) {
        imgWidth = fullview.width;
    }
    var wrapperStyles = {};
    if (propsWidth !== 'static') {
        wrapperStyles = {
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            width: propsWidth || '100%',
        };
    }
    var imgStyles = {};
    if (propsWidth !== 'static') {
        imgStyles = {
            flexGrow: 0,
            flexShrink: 0,
            width: imgWidth,
        };
    }
    var allowFullview = (fullview.width || 0) > (propsWidth || 0);
    var canBeLinked = config.link || deviation.isPublished;
    var ImageComponent = allowFullview && !canBeLinked ? ImgWithFullview : Img;
    return (React.createElement("div", { className: classnames('daeditor-image-mono', config.size === 'fullWidth'
            ? 'daeditor-full-width'
            : 'daeditor-best-fit', config.alignment && "daeditor-align-" + config.alignment, getThumbGlobalClassNames(deviation)), style: wrapperStyles },
        React.createElement(EditorDeviationLink, { link: config.link, deviation: deviation, linkClass: "gallery-link" },
            React.createElement(ImageComponent, { file: coverThumb, deviation: deviation, imgStyles: imgStyles, width: propsWidth }))));
};
ImageView.displayName = 'ImageView';
export default withFeatureFlags(ImageView);
//# sourceMappingURL=Image.js.map